/* eslint-disable react/no-danger */
/* eslint-disable comma-dangle */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import URLSanitizer from '../services/url-sanitizer';

import noImage from '../images/no-image.png';

import NoteTooltip from './product/note-tooltip';

import styles from './styles/components/product-tile.scss';
import loadingStyles from './styles/components/loading.scss';
import ZoneModal from './zone/zone-modal';
import AgeValidWrapper from './age-valid-wrapper/age-valid-wrapper';

import CategoryBadge from './product/category-badge';

import ExtraDataModal from './product/extra-data-modal';

import APP_ROUTES from '../constants/app-routes';
import history from '../browser-history';

class ProductTile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingImage: true,
            showZoneModal: false,
            showExtraDataModal: false,
            extraDataInfo: {},
        };

        this.addProductToCart = this.addProductToCart.bind(this);
        this.imageLoaded = this.imageLoaded.bind(this);
        this.checkAllProdAreAvailables = this.checkAllProdAreAvailables.bind(this);
    }

    onModalResponse(response, value) {
        if (response === 'accept') {
            const extra = {};
            extra[this.state.extraDataInfo.id] = value;

            this.props.addProductToCart(
                this.props.product.master.id,
                1,
                this.props.currentZone,
                this.props.locale.currentLocale,
                this.props.access_token,
                this.props.order,
                extra
            );
        }
        this.setState((state) => ({
            showExtraDataModal: !state.showExtraDataModal,
        }));
    }

    getCategory() {
        if (this.props.product.attributes && this.props.product.attributes.shipping_category
            && this.props.product.attributes.shipping_category.name
            && this.props.product.attributes.shipping_category.name !== 'Default'
        ) {
            return this.props.product.attributes.shipping_category.name;
        }
        return null;
    }

    getGenericImagesFromProduct = (product) => {
        const allImages = product.images;
        const imagesFromVariants = product.variants.map((variant) => variant.images).flat();
        return allImages.filter((image) => imagesFromVariants.find((variantImage) => variantImage.id === image.id) === undefined);
    };

    filterDuplicatedImages = (images) => {
        const result = [];
        images.forEach((image) => {
            if (image.attributes
                && image.attributes.styles
                && image.attributes.styles[11]
                && image.attributes.styles[11].url
                && result.findIndex((elem) => image.attributes.styles[11].url === elem.attributes.styles[11].url) === -1
            ) {
                result.push(image);
            }
        });
        return result;
    };

    addProductToCart() {
        if (this.props.product.variants.length > 1) {
            history.push(`${APP_ROUTES.products}/${this.props.product.attributes.slug}`);
            return;
        }

        if (this.props.product.data_extra_types && this.props.product.data_extra_types[0] && this.props.product.data_extra_types[0].attributes) {
            const { id, attributes: { field_type: fieldType, is_required: isRequired, label } } = this.props.product.data_extra_types[0];
            this.setState((state) => ({
                showExtraDataModal: !state.showExtraDataModal,
                extraDataInfo: {
                    fieldType,
                    isRequired,
                    label,
                    id,
                },
            }));
        } else {
            this.props.addProductToCart(this.props.product.master.id, 1, this.props.currentZone, this.props.locale.currentLocale, this.props.access_token, this.props.order);
        }
    }

    checkAllProdAreAvailables() {
        if (!this.props.currentZone) {
            console.log('CurrentZone is NOT available');
            return false;
        }
        if (!this.props.product || !this.props.product.attributes || !this.props.product.attributes.zone_ids) {
            console.log('Product zone_ids are NOT available');
            return false;
        }
        if (!this.props.product.attributes.zone_ids.some((zone) => zone === this.props.currentZone)) {
            console.log('Current product NOT available for curent zone', this.props.product.attributes.zone_ids, this.props.currentZone);
            return false;
        }

        if (!this.props.order || !this.props.order.line_items || (this.props.order.line_items.length > 0 && !this.props.order.line_items[0].attributes.zone_ids)) {
            console.log('Order zones are NOT available');
            return false;
        }
        return this.props.order.line_items.length === 0 || this.props.order.line_items.every((item) => item.attributes.zone_ids.some((zone) => zone === this.props.currentZone));
    }

    imageLoaded() {
        this.setState({ loadingImage: false });
    }

    render() {
        const handleCloseModal = (cleanOrder) => {
            if (cleanOrder) {
                this.props.emptyCart(this.props.order, this.props.locale.currentLocale);
            }
            this.setState({
                showZoneModal: false,
            });
        };

        let imageUrl = '';

        const defaultImage = this.filterDuplicatedImages(this.getGenericImagesFromProduct(this.props.product).concat(this.props.product.master.images));

        const image = defaultImage[0];

        const productName = this.props.product
            && this.props.product.attributes
            && this.props.product.attributes.name;

        const productPrice = this.props.product
            && this.props.product.master
            && this.props.product.master.attributes
            && this.props.product.master.attributes.display_price;

        const productDescription = this.props.product
            && this.props.product.attributes
            && this.props.product.attributes.description;

        const getProductDescriptionMarkup = () => ({ __html: productDescription });

        const productInStock = this.props.product
            && this.props.product.attributes
            && this.props.product.attributes.in_stock;

        const productNote = this.props.product
            && this.props.product.attributes
            && this.props.product.attributes.notes;

        const productShowURL = this.props.product
            && this.props.product.attributes
            && `/products/${this.props.product.attributes.slug}`;

        const productAgeValid = this.props.product
            && this.props.product.attributes
            && this.props.product.attributes.age_valid;

        if (image && image.attributes && image.attributes.styles) {
            imageUrl = URLSanitizer.makeAbsolute(image.attributes.styles[5].url);
        }

        return (
            <div>
                {productShowURL && (
                    <div className={`col-lg-4 col-md-4 col-sm-6 col-xs-12 ${styles.productTile}`}>
                        <div className={`${styles.productBlock}`}>
                            { this.getCategory() && (<CategoryBadge label={this.getCategory()} color="#FE6902" />) }
                            <div className={`thumb-img-block ${styles.imgMain}`}>
                                <AgeValidWrapper productAgeValid={productAgeValid}>
                                    <Link to={productShowURL} className="product-link">
                                        <div className={`${styles.imgLoadingParent}`}>
                                            <img
                                                onLoad={this.imageLoaded}
                                                className={`product-tile-image ${styles.productMainImage}`}
                                                alt={productName}
                                                src={imageUrl || noImage}
                                                style={{ display: this.state.loadingImage ? 'none' : 'block', objectFit: imageUrl ? 'contain' : 'cover' }}
                                            />
                                            {!productInStock && (
                                                <span className={styles.outStock}>
                                                    <FormattedMessage
                                                        id="out-of-stock"
                                                        defaultMessage="Out Stock"
                                                    />
                                                </span>
                                            )}
                                            {productNote && (
                                                <NoteTooltip note={productNote}>
                                                    <span className={styles.note}>
                                                        <FormattedMessage
                                                            id="note"
                                                            defaultMessage="Notes"
                                                        />
                                                    </span>
                                                </NoteTooltip>
                                            )}
                                            <div className={styles.imgLoadingContainer} style={{ display: this.state.loadingImage ? 'block' : 'none' }}>
                                                <div className={loadingStyles.spinnerDark} />
                                            </div>
                                        </div>
                                    </Link>
                                </AgeValidWrapper>
                            </div>
                            <div className={`${styles.textBlock}`}>
                                <h4 className={`${styles.titleCard}`}>
                                    <AgeValidWrapper productAgeValid={productAgeValid}>
                                        <Link to={productShowURL}>
                                            {productName}
                                        </Link>
                                    </AgeValidWrapper>
                                </h4>
                                <h5 className={`${styles.commentFirst}`}>
                                    <Link to={`${productShowURL}?a=comment`}>
                                        {/* <FormattedMessage id="be-the-first-to-comment" defaultMessage="Be the first to comment." /> */}
                                    </Link>
                                </h5>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div dangerouslySetInnerHTML={getProductDescriptionMarkup()} className={`${styles.productDescription}`} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className={`text-right ${styles.lastRow}`}>
                                            <div className={styles.price}>
                                                {productPrice}
                                            </div>
                                            <AgeValidWrapper productAgeValid={productAgeValid}>
                                                <div className={styles.buttons}>
                                                    <span className={styles.wishlistButton}>
                                                        <span className="glyphicon glyphicon-heart" />
                                                    </span>
                                                    <span
                                                        className={!this.props.order.addingProductToCart
                                                            ? styles.addToCartButton
                                                            : styles.disableAddToCartButton}
                                                        onClick={!this.props.order.addingProductToCart
                                                            ? this.addProductToCart
                                                            : () => { }}
                                                    >
                                                        <span className="glyphicon glyphicon-shopping-cart" />
                                                    </span>
                                                </div>
                                            </AgeValidWrapper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ZoneModal
                            show={this.state.showZoneModal}
                            onHide={handleCloseModal}
                        />
                    </div>
                )}
                {this.state.showExtraDataModal && (
                    <ExtraDataModal
                        fieldType={this.state.extraDataInfo.fieldType}
                        label={this.state.extraDataInfo.label}
                        isRequired={this.state.extraDataInfo.isRequired}
                        onResponse={(response, value) => { this.onModalResponse(response, value); }}
                    />
                )}
            </div>
        );
    }
}

export default ProductTile;



/** WEBPACK FOOTER **
 ** ./src/components/product-tile.jsx
 **/